/* eslint-disable no-loop-func */
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import cssClasses from "./Login.module.css";

import strip1 from "../../Assets/Images/strip1.svg";
import strip2 from "../../Assets/Images/strip2.svg";
import strip3 from "../../Assets/Images/strip3.svg";
import strip4 from "../../Assets/Images/strip4.svg";
import logo from "../../Assets/Images/vjLogo.jpg";

import { useNavigate } from "react-router-dom";

import { useDispatch } from "react-redux";
import action from "../../Redux Store/actions";
import axios from "axios";
//subComponent
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
// import GreenChecked from "../Icons/GreenChecked";
import InfoIcon from "../Icons/InfoIcon";

import IdRecoveryModal from "../IdRecoveryModal/IdRecoveryModal"; 
//Services
import {
  loginWithEmailPass,
  checkCPIsAprroved,
  checkFOSIsAprroved,
  checkIsEmailExist,
  handleErrors,
  insertLoginLogs,
  LoginLogs,
  getCpId,
  addKYCDoc,
  uploadFileToDb,
  signUpMigrationCP,
  getFOSId,
  addKYCDocFos,
  signUpFos,
  signUpFosMigration,
  checkForUniqueDocs,
  updatePassword,
  authSignUp,
  insertUser,
} from "../../Services/LoginService";
import { Network } from "@capacitor/network";
import { Geolocation } from "@capacitor/geolocation";
import { Capacitor } from "@capacitor/core";
import { errorTost, offlineToast, successTost } from "../../Services/Toast";
import { readReraPdfFile, restartServer, sendMessage } from "../../Services/SmsService";

import * as XLSX from "xlsx";
import {
  getAadharCardDetails,
  getAccountDetails,
  getGSTInfo,
  getPAN_cardDetails,
  getReraDetails,
} from "../../Services/SurepassApi";
import { supabase } from "../../supabaseClient";
import UpdatePassword from "../../Modals/UpdatePassword/UpdatePassword";

const useStyles = makeStyles((theme) => ({
  title: {
    color: "#1C1C1C",
    fontFamily: "Inter-Medium",
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
    marginBottom: "1rem",
  },
  label: {
    display: "inline-block",
    fontFamily: "Inter-Medium",
    fontWeight: "400",
    fontSize: "1.4rem",
    lineheight: "2rem",
    /* identical to box height, or 143% */

    /* Gray/500 */

    color: "#667085",
    marginRight: "0.4rem",
  },
  signUp: {
    display: "inline-block",
    fontFamily: "Inter-Medium",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineheight: "2rem",
    cursor: "pointer",
    color: "#175CD3",
  },
}));

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyles();
  const [isLoginLoading, setIsLoginLoading] = useState(false);
  const [loginDetails, setLoginDetails] = useState({
    emailId: "",
    password: "",
  });
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [message, setMessage] = useState("");
  const [messageStatus, setMessageStatus] = useState("");
  const [helperText, setHelperText] = useState({
    isEmailValid: "",
    isPasswordValid: "",
  });
  const [updatePasswordOpenModal, setUpdatePasswordOpenModal] = useState(false);
  const [userData, setUserData] = useState(null);
    const [showIdModal, setShowIdModal] = useState(false);




  
console.log('Merged from branch'); 
 function validateLogin() {
    var form = true;
    if (loginDetails.emailId === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.isEmailValid = "Please Enter CP/FoS Id";
        return { ...preValue };
      });
    }
    if (loginDetails.password === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.isPasswordValid = "Please Enter Password";
        return { ...preValue };
      });
    }
    return {
      flag: form,
    };
  }
  function getGeoLocation() {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(geoSuccess, geoError);
      } else {
        resolve({
          success: false,
          message: "Geolocation is not supported by this browser.",
        });
      }

      function geoSuccess(position) {
        var latitude = position.coords.latitude;
        var longitude = position.coords.longitude;
        resolve({ success: true, data: { latitude, longitude } });
      }
      function geoError() {
        resolve({ success: false, message: "Geocoder failed." });
      }
    });
  }

  async function login() {
    let flag = validateLogin();
    if (
      flag.flag && // helperText.isEmailValid === "" &&
      helperText.isPasswordValid === ""
    ) {
      let signInType = loginDetails.emailId.substring(0, 5).toUpperCase() === 'FOSID' ? 'FOS' : 'CP';
      let id = signInType === 'CP' ? loginDetails.emailId.substring(4, 10) : loginDetails.emailId.substring(5, 11);
      // let id =
      //   loginDetails.emailId.substring(5, 13) +
      //   loginDetails.emailId.substring(14, 18);
      Network.getStatus().then((status) => {
        console.log(status.connected);
        if (status.connected) {
          restartServer().then((resp) => {
            console.log(resp);
          });
          setIsLoginLoading(true);
          checkIsEmailExist(signInType, id)
            .then((resp) => {
              console.log(resp);
              if (resp.length === 0) {
                errorTost("Invalid Credentials");
                setIsLoginLoading(false);
              } else {
                loginWithEmailPass(
                  signInType === "CP"
                    ? resp[0].CpContactPerson[0].email
                    : resp[0].email,
                  loginDetails.password
                )
                  .then(async (user) => {
                    console.log({ user })

                    // !!Update Password modal
                    if (resp[0].isPasswordUpdated === false) {
                      setUpdatePasswordOpenModal(true);
                      setUserData({ ...user.user, cpId: resp[0].cpId });
                    }
                    console.log("User", user.user);
                    let logObj = {
                      // userId: user.user.id,
                      ...(signInType === "CP"
                        ? { cpContactPersonId: user.user.id }
                        : { fosId: user.user.id }),
                      action: "login",
                      latitude: "",
                      longitude: "",
                      ipv4: "",
                    };
                      await axios.get("https://api.ipify.org/").then(async (resp) => {
                      logObj.ipv4 = resp.data;
                      console.log(Capacitor.isNativePlatform());
                      if (Capacitor.isNativePlatform()) {
                        const coordinates =
                          await Geolocation.getCurrentPosition();
                        console.log("coordinates", coordinates.coords);
                        logObj.latitude = coordinates.coords.latitude;
                        logObj.longitude = coordinates.coords.longitude;
                      } else {
                        const getGeoLocationResponse = await getGeoLocation();
                        if (getGeoLocationResponse.success) {
                          logObj.latitude =
                            getGeoLocationResponse.data.latitude;
                          logObj.longitude =
                            getGeoLocationResponse.data.longitude;
                        }
                      }
                      insertLoginLogs(logObj)
                        .then((insertRes) => {
                          console.log({ insertRes });
                        })
                        .catch((err) => {
                          setIsLoginLoading(false);
                          errorTost("Error while inserting in Logs");
                        });
                    });
                    if (resp[0].isPasswordUpdated === null || resp[0].isPasswordUpdated) {
                      if (user.user.user_metadata.type === "CP") {
                        checkCPIsAprroved(user.user.id)
                          .then((response) => {
                            console.log(user);
                            if (response[0].cpId.approvalStatus === "approved") {
                              setIsLoginLoading(false);
                              successTost(user.message);
                              // navigate("/Home/Leads");
                              navigate("/Home");
                              console.log("cpId", response[0]);
                              console.log("2", user.user);
                              console.log("3", user.user.user_metadata);
                              
                              dispatch(
                                action.authLogin({
                                  ...response[0],
                                  ...response[0].cpId,
                                  type: user.user.user_metadata.type,
                                })
                              );
                            } else if (
                              response[0].cpId.approvalStatus === "pending"
                            ) {
                              setOpenConfirmation(true);
                              setMessageStatus("Waiting for approval");
                              setMessage(
                                "You have submitted your details successfully. Your account will be verified soon."
                              );
                              setIsLoginLoading(false);
                            } else {
                              setIsLoginLoading(false);
                              successTost(user.message);
                              // navigate("/Home/Leads");
                              navigate("/Home/Profile");
                              dispatch(
                                action.authLogin({
                                  ...response[0],
                                  ...response[0].cpId,
                                  type: user.user.user_metadata.type,
                                })
                              );
                            }
                          })
                          .catch((err) => {
                            setIsLoginLoading(false);
                            handleErrors(err, "login->cpIsApproved");
                          });
                      } else if (user.user.user_metadata.type === "FOS") {
                        checkFOSIsAprroved(user.user.id)
                          .then((data) => {
                            console.log({ data });
                            data = data.map((el) => ({
                              ...el,
                              cpData: el.cpId,
                              cpId: el.cpId ? el.cpId.cpId : null,
                            }));
                            if (data[0].approvalStatus === "approved") {
                              successTost(user.message);
                              // navigate("/Home/Leads");
                              //   ...response[0],
                              //   ...response[0].cpId,
                              //  type:user.user.user_metadata.type,
                              if (data[0].cpData.approvalStatus === "approved") {
                                navigate("/Home");
                              } else {
                                navigate("/Home/Profile");
                              }
                              dispatch(
                                action.authLogin({
                                  ...data[0],
                                  type: user.user.user_metadata.type,
                                })
                              );
                            } else if (data[0].approvalStatus === "pending") {
                              // setOpenConfirmation(true);
                              // setMessageStatus("Waiting for approval");
                              // setMessage(
                              //   "You have submitted your details successfully. Your account will be verified soon."
                              // );
                              navigate("/Home/Profile");
                              dispatch(
                                action.authLogin({
                                  ...data[0],
                                  type: user.user.user_metadata.type,
                                })
                              );
                              setIsLoginLoading(false);
                            } else {
                              setOpenConfirmation(true);
                              // setMessageStatus("Rejected");
                              // setMessage(data[0].rejectionReason);
                              setIsLoginLoading(false);
                              navigate("/Home/Profile");
                              dispatch(
                                action.authLogin({
                                  ...data[0],
                                  type: user.user.user_metadata.type,
                                })
                              );
                            }
                          })
                          .catch((err) => {
                            setIsLoginLoading(false);
                            handleErrors(err, "login->fosIsApproved");
                          });
                      }
                    } else {
                      console.log('resp[0].isPasswordUpdated', resp[0].isPasswordUpdated);
                    }
                  })
                  .catch((err) => {
                    setIsLoginLoading(false);
                    handleErrors(err, "login->authSignIn");
                  });
              }
            })
            .catch((err) => {
              setIsLoginLoading(false);
              handleErrors(err, "login->checkIsEmailExist");
            });
        } else {
          offlineToast();
        }
      });
    }
  }

  function navigateToSignUp() {
    restartServer().then((resp) => {
      console.log(resp);
    });
    navigate("/Register");
  }

  return (
    <div className={cssClasses.wrapperPage}>
      <div className={cssClasses.backgroundImage}>
        <img
          src={strip2}
          className={cssClasses.strip2}
          alt="backgroundImage"
        ></img>
        <img
          src={strip3}
          className={cssClasses.strip3}
          alt="backgroundImage"
        ></img>
        <div className={cssClasses.registerationBlock}>
          <div>
            <img src={logo} style={{ width: "23rem" }} alt="vj-logo"></img>
          </div>
          <div className={classes.title}>Welcome Back</div>
          <div style={{ textAlign: "left", textTransform: "uppercase" }}>
            <CustomInput
              value={loginDetails.emailId}
              label={"User CP/FOS Id"}
              mandatory={true}
              handleChange={(newValue) => {
                console.log(newValue);
                // if (newValue.length <= 11) {
                // if (newValue.length != 11) {
                //   setHelperText((pre) => {
                //     pre.isEmailValid = "User Id must be of 18 characters";
                //     return { ...pre };
                //   });
                // } else {
                //   setHelperText((pre) => {
                //     pre.isEmailValid = "";
                //     return { ...pre };
                //   });
                // }
                setLoginDetails((pre) => {
                  pre.emailId = newValue;
                  return { ...pre };
                });
                helperText.isEmailValid = "";
                // }
              }}
              placeholder="Enter CP/FOS Id"
              inputType="label"
              helperText={helperText.isEmailValid}
            // onKeyPress={(event) => {
            //   console.log(event);
            //   if (event.key === "Enter") {
            //     login();
            //   }
            // }}
            />
          </div>
          <div style={{ textAlign: "left" }}>
            <CustomInput
              value={loginDetails.password}
              label={"Password"}
              mandatory={true}
              handleChange={(value) => {
                let errors = helperText;
                if (!value.trim()) {
                  errors.isPasswordValid = "Please Enter Password";
                } else if (value.search(/[A-Z]/) < 0) {
                  errors.isPasswordValid =
                    "Password should contain atleast 1 Uppercase.";
                }
                //  else if (value.search(/[a-z]/) < 0) {
                //   errors.isPasswordValid =
                //     "Password should contain atleast 1 LowerCase.";
                // } 
                else if (value.search(/[0-9]/) < 0) {
                  errors.isPasswordValid =
                    "Password should contain atleast 1 number.";
                } else if (value.length < 6) {
                  errors.isPasswordValid =
                    "Password should contain atleast 6 Characters.";
                } else {
                  errors.isPasswordValid = "";
                }
                setHelperText(errors);
                let pre = Object.assign({}, loginDetails);
                pre.password = value;
                setLoginDetails({ ...pre });
              }}
              placeholder="Enter your password"
              inputType="password"
              helperText={helperText.isPasswordValid}
              onKeyPress={(event) => {
                console.log(event);
                if (event.key === "Enter") {
                  login();
                }
              }}
            />
          </div>
          <div>
            <Button
              style={{
                color: "#ffffff",
                backgroundColor: "#155EEF",
              }}
              btnName={"Login"}
              clicked={login}
              isLoading={isLoginLoading}
              loaderColor={"#fff"}
            />
          </div>

          <div>
            <div className={classes.label}>Don’t have an account?</div>
            <div className={classes.signUp} onClick={navigateToSignUp}>
              Signup
            </div>
          </div>
          <div>
            <div className={classes.signUp} onClick={() => {
              navigate("/ForgetPassword");
            }}>
              Forgot Password?
            </div>
            <div className={classes.label} style={{ marginLeft: '0.5rem' }}>Reset your password now!</div>
          </div>

            <div>
        <div className={classes.signUp} onClick={() => setShowIdModal(true)}>
          Forgot CPID or FOSID?
        </div>
        <div className={classes.label} style={{ marginLeft: '0.5rem' }}>Recover using your PAN</div>
      </div>

      <IdRecoveryModal open={showIdModal} onClose={() => setShowIdModal(false)} />
        </div>
        <ConfirmationAlert
          open={openConfirmation}
          close={() => {
            setOpenConfirmation(false);
          }}
          icon={<InfoIcon width={"4.8rem"} height={"4.8rem"} />}
          title={messageStatus}
          subTitle={message}
          confirm={(value) => {
            console.log(value);
          }}
          buttonTitle={"Cancel"}
        // returnRespButton={"Confirm"}
        />
      </div>
      {updatePasswordOpenModal && (

        <UpdatePassword open={updatePasswordOpenModal} handleClose={() => {
          setUpdatePasswordOpenModal(false);
        }}
          data={userData}
          saveResp={(value) => {
            if (value) {
              if (userData.user_metadata.type === "CP") {
                checkCPIsAprroved(userData.id)
                  .then((response) => {
                    console.log(userData);
                    if (response[0].cpId.approvalStatus === "approved") {
                      setIsLoginLoading(false);
                      successTost(userData.message);
                      // navigate("/Home/Leads");
                      navigate("/Home");
                      console.log("cpId", response[0]);
                      console.log("2", userData);
                      console.log("3", userData.user_metadata);
                      dispatch(
                        action.authLogin({
                          ...response[0],
                          ...response[0].cpId,
                          type: userData.user_metadata.type,
                        })
                      );
                    } else if (
                      response[0].cpId.approvalStatus === "pending"
                    ) {
                      setOpenConfirmation(true);
                      setMessageStatus("Waiting for approval");
                      setMessage(
                        "You have submitted your details successfully. Your account will be verified soon."
                      );
                      setIsLoginLoading(false);
                    } else {
                      setIsLoginLoading(false);
                      successTost(userData.message);
                      // navigate("/Home/Leads");
                      navigate("/Home/Profile");
                      dispatch(
                        action.authLogin({
                          ...response[0],
                          ...response[0].cpId,
                          type: userData.user_metadata.type,
                        })
                      );
                    }
                  })
                  .catch((err) => {
                    setIsLoginLoading(false);
                    handleErrors(err, "login->cpIsApproved");
                  });
              } else if (userData.user_metadata.type === "FOS") {
                checkFOSIsAprroved(userData.id)
                  .then((data) => {
                    console.log({ data });
                    data = data.map((el) => ({
                      ...el,
                      cpData: el.cpId,
                      cpId: el.cpId?.cpId,
                    }));
                    if (data[0].approvalStatus === "approved") {
                      successTost(userData.message);
                      // navigate("/Home/Leads");
                      //   ...response[0],
                      //   ...response[0].cpId,
                      //  type:user.user.user_metadata.type,
                      if (data[0].cpData.approvalStatus === "approved") {
                        navigate("/Home");
                      } else {
                        navigate("/Home/Profile");
                      }
                      dispatch(
                        action.authLogin({
                          ...data[0],
                          type: userData.user_metadata.type,
                        })
                      );
                    } else if (data[0].approvalStatus === "pending") {
                      // setOpenConfirmation(true);
                      // setMessageStatus("Waiting for approval");
                      // setMessage(
                      //   "You have submitted your details successfully. Your account will be verified soon."
                      // );
                      navigate("/Home/Profile");
                      dispatch(
                        action.authLogin({
                          ...data[0],
                          type: userData.user_metadata.type,
                        })
                      );
                      setIsLoginLoading(false);
                    } else {
                      setOpenConfirmation(true);
                      // setMessageStatus("Rejected");
                      // setMessage(data[0].rejectionReason);
                      setIsLoginLoading(false);
                      navigate("/Home/Profile");
                      dispatch(
                        action.authLogin({
                          ...data[0],
                          type: userData.user_metadata.type,
                        })
                      );
                    }
                  })
                  .catch((err) => {
                    setIsLoginLoading(false);
                    handleErrors(err, "login->fosIsApproved");
                  });
              }
            }
          }}
        />
      )}
    </div>
  );
}